export class LocationBO {
    id: string | null;
    name: string;
    weekStartDayLid: number;
    weekStartDayLovName: string;
    weekEndDayLid: number;
    weekEndDayLovName: string;
}

export class GetLocationBO {
    role: string;
    user: string | null;
    searchColumn: string;
    searchText: string;
    userId: string | null;
    agencyId: string | null;
    clientId: string;
    locationId: string | null;
    currentpageno: number = 1;
    orderType: string = "asc";
    pageitem: number = 10;
    orderColumn: string = "name";
    type: string = "string";
    field: string = "name";
    operator: string = "startswith";
    value: string = "";
    matchCase: boolean = false;
}

export class functionpermission {
    locationcreate: boolean = true
    locationupdate: boolean = true

    locationdelete: boolean = true

}